import React from 'react'
import { CheckBoxRadioGroupContainer, RadioReadOnlyContainer, ShareButtonSize } from './styles'

interface RadioProps {
    name: string
    isCheck: boolean
    label?: string
    isDisable?: boolean
    onChange: () => void
    size?: ShareButtonSize
    isReadOnly?: boolean
}
const Radio: React.FC<RadioProps> = ({
    name,
    onChange,
    isCheck,
    label,
    isDisable = false,
    size = 'm',
    isReadOnly = false,
}) => {
    return (
        <>
            <CheckBoxRadioGroupContainer isDisplayRow={false} isCheck={isCheck}>
                <div className="input-group">
                    {isReadOnly && isCheck ? (
                        <RadioReadOnlyContainer size={size} />
                    ) : (
                        <>
                            <input
                                type="radio"
                                name={name}
                                color="governorBay"
                                checked={isCheck}
                                onChange={onChange}
                                disabled={isDisable || isReadOnly}
                            />
                            {label && <div>{label}</div>}
                        </>
                    )}
                </div>
            </CheckBoxRadioGroupContainer>
        </>
    )
}
export default Radio
